import * as React from 'react'
import { Redirect, Route, Switch } from 'react-router'
import { ToastContainer } from 'react-toastify'
import NavBar from 'app/components/Nav/NavBar'
import Earn from 'app/features/earn/Earn'

/*
NOTE: Hierarchy matters with routes!
Home needs to be last.
Nested stuff needs to be in right order?
*/

const Routes = (
  <>
    <div className="flex flex-col justify-items-stretch h-full">
      <NavBar />
      <div className="flex-1 bg-ebony-clay-500 relative">
        <Switch>
          <Route exact path="/">
            <Redirect to="/earn" />
          </Route>
          {/* <Route path="/dashboard" render={() => <div>Home</div>} /> */}
          <Route path="/earn" component={Earn} />
          <Route render={() => <div>Page not found</div>} />
          {/* TODO: Make not found page */}
        </Switch>
        <ToastContainer
          className="md:mt-16"
          theme="dark"
          hideProgressBar={true}
          draggable
          pauseOnFocusLoss
          closeOnClick
          toastClassName={(context) =>
            `${
              context?.defaultClassName || ''
            } bg-ebony-clay-600 sm:rounded-lg font-sans`
          }
        />
      </div>
    </div>
  </>
)

export default Routes
